<template>
  <div style="display: none" />
</template>

<script>
import { mapGetters } from 'vuex'
import * as turf from '@turf/turf'

export default {
  name: 'CoverageLayer',
  props: {
    /**
     * Indicates whether the MapBox instance is ready
     */
    loaded: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      layerName: 'coverage_plan',
      minzoom: 10,
      layout: {
        visibility: 'visible',
      },
    }
  },
  computed: {
    ...mapGetters('planmode', [
      'getFilteredChargingpoints',
      'hasLoadedChargingPoints',
    ]),
    ...mapGetters('layers', [
      'getLayerDetails',
    ]),
    ...mapGetters('prognose', [
      'labelLayer',
    ]),
  },
  watch: {
    getFilteredChargingpoints: {
      immediate: true,
      deep: true,
      handler() {
        this.removeLayersAndSource()
        this.loaded && this.addLayers()
      },
    },

    getLayerDetails: {
      immediate: true,
      deep: true,
      handler(layers) {
        this.layout.visibility = layers.find(layer => layer.id === this.layerName)?.visible ? 'visible' : 'none'
      },
    },
  },
  methods: {
    // TODO: refactor
    generateGeoJson(points, radius) {
      const geoJson = {
        type: 'FeatureCollection',
        features: [],
      }

      points = Array.isArray(points) ? points : []

      points.forEach(chargingpoint => {
        if (chargingpoint?.coordinates?.length) {
          const coords = [Number(chargingpoint.coordinates[0]), Number(chargingpoint.coordinates[1])]
          const circleGeoJSON = turf.circle(coords, radius, { units: 'meters' })
          geoJson.features.push(circleGeoJSON)
        }
      })
      return geoJson
    },
    addLayers() {
      const radiusInMeters = 250
      const circleGeoJSON = this.generateGeoJson(this.getFilteredChargingpoints, radiusInMeters)

      this.$nextTick(() => {
        const circlesLayer = {
          id: this.layerName,
          type: 'fill',
          minzoom: this.minzoom,
          source: {
            type: 'geojson',
            data: circleGeoJSON,
          },
          layout: this.layout,
          paint: {
            'fill-color': '#8BC34A',
            'fill-opacity': 0.5,
          },
        }
        this.removeLayersAndSource()
        this.$store.map.addLayer(circlesLayer, this.labelLayer, 'chargingpoints' || null)

      })
    },
    removeLayersAndSource() {
      if (this.$store.map?.getLayer(this.layerName)) {
        this.$store.map.removeLayer(this.layerName)
      }
      if (this.$store.map?.getSource(this.layerName)) {
        this.$store.map.removeSource(this.layerName)
      }
    },
  },
}
</script>
